import { Translate } from "react-i18nify";

export const AssessmentNotFound = (): JSX.Element => {
    return (
        <div>
            <h1>
                <Translate value="admin.assessmentNotFound" />
            </h1>
        </div>
    );
};
